{
  "items": [
    {
      "id": "invincible",
      "kind": "protector",
      "name": "L’Invincible",
      "visible": true,
      "image": "/assets/accessoires/invincible.webp",
      "fr": {
        "title": "Protège-matelas Excelsior L’Invincible",
        "line": "Imperméable, dessous antidérapant, protège les 5 côtés du matelas.",
        "short": "L’Invincible"
      },
      "en": {
        "title": "Excelsior Invincible mattress protector",
        "line": "Waterproof, non-slip underside, covers all 5 sides of the mattress.",
        "short": "Invincible"
      },
      "variants": [
        {
          "key": "Simple|bas",
          "size": "Simple",
          "profile": "bas",
          "sku": "G3-10INVIN39",
          "upc": "675855021465",
          "price": 79.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954584252703:1"
        },
        {
          "key": "Simple|haut",
          "size": "Simple",
          "profile": "haut",
          "sku": "G3-INVIN39",
          "upc": "675855021472",
          "price": 79.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954584285471:1"
        },
        {
          "key": "Simple XL|bas",
          "size": "Simple XL",
          "profile": "bas",
          "sku": "G3-10INVINTXL",
          "upc": "675855021489",
          "price": 89.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954584318239:1"
        },
        {
          "key": "Simple XL|haut",
          "size": "Simple XL",
          "profile": "haut",
          "sku": "G3-INVINTXL",
          "upc": "675855021496",
          "price": 89.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954584351007:1"
        },
        {
          "key": "Double|bas",
          "size": "Double",
          "profile": "bas",
          "sku": "G3-10INVIN54",
          "upc": "675855021502",
          "price": 99.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954584383775:1"
        },
        {
          "key": "Double|haut",
          "size": "Double",
          "profile": "haut",
          "sku": "G3-INVIN54",
          "upc": "675855021519",
          "price": 99.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954584416543:1"
        },
        {
          "key": "Queen|bas",
          "size": "Queen",
          "profile": "bas",
          "sku": "G3-10INVIN60",
          "upc": "675855021526",
          "price": 109.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954584449311:1"
        },
        {
          "key": "Queen|haut",
          "size": "Queen",
          "profile": "haut",
          "sku": "G3-INVIN60",
          "upc": "675855021533",
          "price": 109.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954584482079:1"
        },
        {
          "key": "King|bas",
          "size": "King",
          "profile": "bas",
          "sku": "G3-10INVIN78",
          "upc": "675855021540",
          "price": 119.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954584514847:1"
        },
        {
          "key": "King|haut",
          "size": "King",
          "profile": "haut",
          "sku": "G3-INVIN78",
          "upc": "675855021557",
          "price": 119.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954584547615:1"
        }
      ]
    },
    {
      "id": "rafraichissant",
      "kind": "protector",
      "name": "Rafraîchissant",
      "visible": true,
      "image": "/assets/accessoires/rafraichissant.webp",
      "fr": {
        "title": "Protège-matelas Excelsior Rafraîchissant",
        "line": "Surmatelas Dri-Cool qui évacue l’humidité, amovible par fermeture éclair.",
        "short": "Rafraîchissant"
      },
      "en": {
        "title": "Excelsior Stay Cool mattress protector",
        "line": "Dri-Cool topper that wicks moisture away, zips off for washing.",
        "short": "Stay Cool"
      },
      "variants": [
        {
          "key": "Simple|bas",
          "size": "Simple",
          "profile": "bas",
          "sku": "G3-10STAYCOOL39",
          "upc": "675855021298",
          "price": 109.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954585039135:1"
        },
        {
          "key": "Simple|haut",
          "size": "Simple",
          "profile": "haut",
          "sku": "G3-STAYCOOL39",
          "upc": "675855021304",
          "price": 109.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954585071903:1"
        },
        {
          "key": "Simple XL|bas",
          "size": "Simple XL",
          "profile": "bas",
          "sku": "G3-10STAYCOLTXL",
          "upc": "675855021311",
          "price": 119.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954585104671:1"
        },
        {
          "key": "Simple XL|haut",
          "size": "Simple XL",
          "profile": "haut",
          "sku": "G3-STAYCOOLTXL",
          "upc": "675855021328",
          "price": 119.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954585137439:1"
        },
        {
          "key": "Double|bas",
          "size": "Double",
          "profile": "bas",
          "sku": "G3-10STAYCOOL54",
          "upc": "675855021335",
          "price": 139.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954585170207:1"
        },
        {
          "key": "Double|haut",
          "size": "Double",
          "profile": "haut",
          "sku": "G3-STAYCOOL54",
          "upc": "675855021342",
          "price": 139.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954585202975:1"
        },
        {
          "key": "Queen|bas",
          "size": "Queen",
          "profile": "bas",
          "sku": "G3-10STAYCOOL60",
          "upc": "675855021359",
          "price": 159.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954585235743:1"
        },
        {
          "key": "Queen|haut",
          "size": "Queen",
          "profile": "haut",
          "sku": "G3-STAYCOOL60",
          "upc": "675855021366",
          "price": 159.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954585268511:1"
        },
        {
          "key": "King|bas",
          "size": "King",
          "profile": "bas",
          "sku": "G3-10STAYCOOL78",
          "upc": "675855021373",
          "price": 169.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954585301279:1"
        },
        {
          "key": "King|haut",
          "size": "King",
          "profile": "haut",
          "sku": "G3-STAYCOOL78",
          "upc": "675855021380",
          "price": 169.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954585334047:1"
        }
      ]
    },
    {
      "id": "summit",
      "kind": "protector",
      "name": "Summit",
      "visible": true,
      "image": "/assets/accessoires/summit.webp",
      "fr": {
        "title": "Protège-matelas Excelsior Summit",
        "line": "Surmatelas régulateur de température, amovible par fermeture éclair.",
        "short": "Summit"
      },
      "en": {
        "title": "Excelsior Summit mattress protector",
        "line": "Temperature-regulating topper, zips off for washing.",
        "short": "Summit"
      },
      "variants": [
        {
          "key": "Simple XL|bas",
          "size": "Simple XL",
          "profile": "bas",
          "sku": "G3-10SUMMITTXL",
          "upc": "675855021199",
          "price": 189.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954586317087:1"
        },
        {
          "key": "Simple XL|haut",
          "size": "Simple XL",
          "profile": "haut",
          "sku": "G3-SUMMITTXL",
          "upc": "675855021205",
          "price": 189.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954586349855:1"
        },
        {
          "key": "Double|bas",
          "size": "Double",
          "profile": "bas",
          "sku": "G3-10SUMMIT54",
          "upc": "675855021212",
          "price": 229.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954586382623:1"
        },
        {
          "key": "Double|haut",
          "size": "Double",
          "profile": "haut",
          "sku": "G3-SUMMIT54",
          "upc": "675855021229",
          "price": 229.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954586415391:1"
        },
        {
          "key": "Queen|bas",
          "size": "Queen",
          "profile": "bas",
          "sku": "G3-10SUMMIT60",
          "upc": "675855021236",
          "price": 259.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954586448159:1"
        },
        {
          "key": "Queen|haut",
          "size": "Queen",
          "profile": "haut",
          "sku": "G3-SUMMIT60",
          "upc": "675855021243",
          "price": 259.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954586480927:1"
        },
        {
          "key": "King|bas",
          "size": "King",
          "profile": "bas",
          "sku": "G3-10SUMMIT78",
          "upc": "675855021250",
          "price": 299.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954586513695:1"
        },
        {
          "key": "King|haut",
          "size": "King",
          "profile": "haut",
          "sku": "G3-SUMMIT78",
          "upc": "675855021267",
          "price": 299.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954586546463:1"
        }
      ]
    },
    {
      "id": "oreiller",
      "kind": "pillow",
      "name": "Infinitë",
      "visible": true,
      "image": "/assets/accessoires/oreiller.webp",
      "fr": {
        "title": "Oreiller Excelsior Infinitë",
        "line": "Mousse déchiquetée ajustable, format Jumbo, garanti 5 ans contre l’affaissement.",
        "short": "Oreiller Infinitë"
      },
      "en": {
        "title": "Excelsior Infinitë pillow",
        "line": "Adjustable shredded foam, Jumbo size, 5-year warranty against flattening.",
        "short": "Infinitë pillow"
      },
      "variants": [
        {
          "key": "1",
          "pack": 1,
          "sku": "INFINITE28-1PK",
          "upc": "675855024800",
          "price": 99.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954586611999:1"
        },
        {
          "key": "2",
          "pack": 2,
          "sku": "INFINITE28-2PK",
          "upc": "675855024817",
          "price": 199.99,
          "shopify": "https://bon-prix-electromenagers.myshopify.com/cart/52954586644767:1"
        }
      ]
    }
  ]
}